


import { useEffect, useRef } from "react";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaXTwitter, FaLinkedinIn, FaInstagram,FaDesktop,FaCloudSun,FaWifi,FaLightbulb } from "react-icons/fa6"; // X (Twitter)
import { FaExclamationTriangle } from "react-icons/fa"; // X (Twitter)

// Import your images (replace with your actual image paths)
// import binStatus from "../assets/bin-status.png";
import card1 from "../assets/images/vmd.png";
import card2 from "../assets/images/ecb.png";
import card3 from "../assets/images/pas.png";
import card4 from "../assets/images/wifi.png";
import card5 from "../assets/images/camera.png";
import card6 from "../assets/images/env.png";
import card7 from "../assets/images/flood.png";
import card8 from "../assets/images/temp.png";

import vishal from "../assets/images/vishal.png";
import bghero from "../assets/images/herobg.png";
import bgvideo from "../assets/video/v1.mp4";
import faq from "../assets/images/faq.png";
import vmd from "../assets/images/vblog1.png";
import pas from "../assets/images/vblog2.png";
import ecb from "../assets/images/ecb2.png";
import wifi from "../assets/images/vblog4.png";
import  camera from "../assets/images/vblog5.png";
import  flood from "../assets/images/vblog6.png";
import  temperature from "../assets/images/temp2.png";

import lottie from "lottie-web";
import {
  FaMapMarkerAlt,
  FaCarAlt,
  FaBell,
  FaChartLine,
  FaRoute,
  FaVideo,
  FaStream,
} from "react-icons/fa";
import Footer from "./Footer";
import SocialMediaSidebar from "./SocialMediaSidebar";
import ScrollToTopButton from "./ScrollToTopButton";

export default function Home() {
  const lottieRef = useRef(null);
  const navigate = useNavigate();
  const [is1366x768, setIs1366x768] = useState(false);

  // Resolution check effect
  useEffect(() => {
    const checkResolution = () => {
      setIs1366x768(window.innerWidth === 1366 && window.innerHeight >= 300);
    };

    checkResolution();
    window.addEventListener("resize", checkResolution);
    return () => window.removeEventListener("resize", checkResolution);
  }, []);

  const routePaths = [
    "/centralized-management",
    "/emergency-response",
    "/environmental-monitoring",
    "/conn-comm",
    "/smart-lightning",
    "/dynamic-information",
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true, // Enables autoplay
    autoplaySpeed: 2000, // Delay between slides in milliseconds (1000ms = 1 second)
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: lottieRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      path: "/01_Homepage.json", // Make sure this path is correct
    });

    return () => anim.destroy(); // Clean up on unmount
  }, []);

  // console.log("is1366x768:", is1366x768);

const blogPosts = [
  {
    img: vmd,
    tag: "Smart Display",
    title: "Enhancing Communication with VMD Technology",
    desc: "Variable Message Displays (VMDs) from GyanYantram enable real-time broadcasting of important alerts, traffic updates, and civic messages. These displays improve city communication by offering dynamic, remote-controlled visual information to the public.",
    authorImg: vishal,
    author: "Admin",
    date: "June 9, 2025",
  },
  {
    img: pas,
    tag: "Public Safety",
    title: "Public Awareness Through PAS Integration",
    desc: "GyanYantram’s Public Address System (PAS) enables real-time voice announcements in crowded or emergency-prone areas. This technology is vital in disaster response, traffic control, and public events, ensuring fast, clear communication to the masses.",
    authorImg: vishal,
    author: "Admin",
    date: "June 9, 2025",
  },
 
  {
    img: camera,
    tag: "Surveillance",
    title: "Real-Time Monitoring with Integrated Cameras",
    desc: "Cameras embedded in smart poles offer 24/7 surveillance for public areas. GyanYantram enables high-resolution monitoring, motion detection, and remote access, making urban environments safer and more secure.",
    authorImg: vishal,
    author: "Admin",
    date: "June 9, 2025",
  },
  {
    img: temperature,
    tag: "Climate Monitoring",
    title: "Tracking Climate with Temperature & Air Sensors",
    desc: "Temperature and environmental sensors embedded in smart poles gather real-time climate data. GyanYantram helps city administrators analyze air quality, heat trends, and pollution levels to drive better urban planning.",
    authorImg: vishal,
    author: "Admin",
    date: "June 9, 2025",
  },
];


  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    className: "custom-dots-slider",
    autoplay: true,
    autoplaySpeed: 2000,
    rtl: true, // <-- Reverses auto slide direction
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const visiblePosts = blogPosts; // always show all

  const slugify = (text) =>
    text
      .toLowerCase()
      .replace(/[^\w ]+/g, "")
      .replace(/ +/g, "-");

  const truncateWords = (text, maxWords) => {
    if (!text) return ""; // Handle null/undefined
    const words = text.split(/\s+/).filter((word) => word.length > 0);
    return words.length > maxWords
      ? `${words.slice(0, maxWords).join(" ")}...`
      : text;
  };

  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <div>
        <ScrollToTopButton />
      </div>
      {/* Hero Section - Conditionally Rendered */}
      {is1366x768 ? (
        // 1366×768 Layout
        <div className="relative w-full min-h-screen overflow-hidden bg-gray-900">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover z-0 opacity-[0.5]"
          >
            <source src={bgvideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="relative z-10 flex flex-col items-center justify-between h-full px-4 py-12 text-white sm:px-6 lg:px-8 flex-grow">
            {/* Centered Text Content */}
            <div className="flex flex-col items-center justify-center flex-grow w-full mt-20">
              <div className="text-center max-w-2xl mt-14">
                <h1 className="text-3xl sm:text-4xl font-extrabold leading-tight">
                  GyanYantram – AI-Enabled OEM For Next-Gen ICT Infrastructure
                </h1>
                <p className="mt-4 text-lg sm:text-xl text-gray-100 font-bold">
                  Welcome To Information Communication Technology
                </p>
              </div>
            </div>

            {/* Slider at Bottom */}
            <div className="w-full max-w-5xl px-4 mt-24">
              <Slider {...sliderSettings} className="custom-slider-1366">
                {[
                  { img: card1, title: "VMD" },
                  { img: card2, title: "ECB" },
                  { img: card3, title: "PAS" },
                  { img: card4, title: "Wi-Fi" },
                  { img: card5, title: "Camera" },
                  { img: card6, title: "Environmental Sensor" },
                  { img: card7, title: "Flood Sensor" },
                  { img: card8, title: "Temperature Sensor" },
                ].map((card, i) => (
                  <div key={i} className="px-2">
                    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 h-full">
                      <img
                        src={card.img}
                        alt={card.title}
                        className="w-full h-32 object-cover border-b-2 border-black"
                      />
                      <div className="p-2 text-center text-xl font-bold text-gray-900">
                        {card.title}
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          <style>{`
      @media (max-width: 1366px) {
        .custom-slider-1366 .slick-slide {
          padding: 0 8px;
        }
        .custom-slider-1366 .slick-list {
          margin: 0 -8px;
        }
      }
    `}</style>
        </div>
      ) : (
        // Default Layout
        <div className="relative w-full min-h-screen flex flex-col bg-gray-900 overflow-hidden">
          <video
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover z-0 opacity-[0.4]"
          >
            <source src={bgvideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <div className="relative z-10 flex flex-col items-center justify-between h-full px-4 py-20 text-white sm:px-6 lg:px-8 flex-grow">
            {/* Centered Text Content */}
            <div className="flex flex-col items-center justify-center flex-grow w-full">
              <div className="text-center max-w-3xl">
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold">
                  SMART POLE – AI-Enabled OEM for Next-Gen ICT Infrastructure
                </h1>
                <p className="mt-6 text-xl md:text-2xl text-gray-100 font-bold">
                   Welcome To Information Communication Technology
                </p>
              </div>
            </div>

            {/* Slider at Bottom */}
            <div className="w-full max-w-6xl px-4 mt-auto mb-[-80px]">
              <Slider {...sliderSettings}>
                {[
                  { img: card1, title: "VMD" },
                  { img: card2, title: "ECB" },
                  { img: card3, title: "PAS" },
                  { img: card4, title: "Wi-Fi" },
                  { img: card5, title: "Camera" },
                  { img: card6, title: "Environmental Sensor" },
                  { img: card7, title: "Flood Sensor" },
                  { img: card8, title: "Temperature Sensor" },

                ].map((card, i) => (
                  <div key={i} className="px-2">
                    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition duration-300 h-full">
                      <img
                        src={card.img}
                        alt={card.title}
                        className="w-full h-40 object-cover border-b-2 border-black"
                      />
                      <div className="p-3 text-center text-xl md:text-2xl font-bold text-gray-900">
                        {card.title}
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      )}

      {/* Vision & Mission Section */}
      <div className="w-full flex flex-col items-center mt-8 px-4 sm:px-6 lg:px-20">
        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl md:text-4xl font-bold text-[#00D084] mb-6 text-center">
          Vision & Mission
        </h2>

        {/* Card Container */}
        <div className="bg-white shadow-2xl border rounded-2xl p-6 sm:p-10 max-w-6xl w-full flex flex-col md:flex-row items-center gap-8 sm:gap-12">
          {/* Profile Image */}
          <div className="flex-shrink-0 mb-6 md:mb-0">
            <img
              src={vishal}
              alt="Vishal Gupta"
              className="w-40 h-40 sm:w-52 sm:h-52 md:w-64 md:h-64 object-cover rounded-full border-4 border-white shadow-lg"
            />
          </div>

          {/* Text Content */}
          <div className="text-center md:text-left">
            <p className="text-lg sm:text-xl md:text-2xl text-gray-800 leading-relaxed mb-4">
              <span className="text-[#00D084] text-3xl sm:text-4xl font-bold mr-2">
                “
              </span>
              Empowering a smarter tomorrow through connected infrastructure and
              AI-driven insights, backed by deep expertise, innovation, and a
              commitment to excellence.
              <span className="text-[#00D084] text-3xl sm:text-4xl font-bold ml-2">
                ”
              </span>
            </p>
            <p className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900">
              Vishal Gupta
            </p>
            <p className="text-sm sm:text-base md:text-lg text-[#00D084] font-semibold">
              Founder & Chairman | AJEEVI
            </p>
          </div>
        </div>
      </div>

      {/* Our Offerings */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-16 bg-white text-center font-poppins">
        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl lg:text-4xl font-bold text-[#00D084] mb-4">
          Our Offerings
        </h2>
        <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900 mb-2">
          Transforming Urban Infrastructure with{" "}
          <span className="text-black font-extrabold">
            GyanYantram
          </span>
        </h3>
        <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-10 sm:mb-12">
GyanYantram is an integrated smart device system that enhances city safety, communication, and monitoring through advanced technologies like VMD, PAS, ECB, Wi-Fi, Cameras, and Sensors.        </p>

        {/* Slick Slider for Cards */}
        <div className="px-4 sm:px-8">
          <Slider
            dots={true}
            infinite={true}
            speed={500}
            slidesToShow={4}
            slidesToScroll={1}
            autoplay={true}
            autoplaySpeed={2000}
            initialSlide={0}
            className="custom-dots-slider"
            responsive={[
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                },
              },
            ]}
          >
            {[
              
 {
    icon: <FaDesktop className="text-[#00D084] text-6xl" />,
    title: "Centralized Monitoring",
    desc: "Manage and monitor all GyanYantram devices VMDs, cameras, sensors.",
  },
  {
    icon: <FaExclamationTriangle className="text-[#00D084] text-6xl" />,
    title: "Emergency Alert System",
    desc: "React instantly with ECB and PAS to broadcast real-time alerts and public safety messages.",
  },
  {
    icon: <FaCloudSun className="text-[#00D084] text-6xl" />,
    title: "Environment & Disaster Sensing",
    desc: "Track environmental data such as air quality, temperature, humidity, and flood detection.",
  },
  {
    icon: <FaWifi className="text-[#00D084] text-6xl" />,
    title: "Smart Connectivity",
    desc: "Built-in Wi-Fi routers ensure real-time communication and data exchange across connected devices.",
  },
  {
    icon: <FaVideo className="text-[#00D084] text-6xl" />,
    title: "24x7 Surveillance",
    desc: "HD cameras provide continuous monitoring for enhanced security and incident recording.",
  },
  {
    icon: <FaStream className="text-[#00D084] text-6xl" />,
    title: "Dynamic Information Display",
    desc: "VMD screens show important updates, traffic info, and emergency messages.",
  },


              // {
              //   icon: <FaLightbulb className="text-[#00D084] text-6xl" />,
              //   title: "Smart Lighting",
              //   desc: "Adaptive lighting solutions that adjust based on environmental conditions and pedestrian traffic for energy efficiency.",
              // },
            ].map((card, idx) => (
              <div key={idx} className="px-2">
                <div className="bg-gray-50 rounded-xl p-6 shadow hover:shadow-md transition flex flex-col justify-between h-[350px]">
                  <div className="bg-white p-4 rounded-xl w-fit mx-auto mb-4">
                    {card.icon}
                  </div>
                  <h4 className="text-lg sm:text-xl font-semibold mb-2">
                    {card.title}
                  </h4>
                  <p className="text-black text-md mb-4">{card.desc}</p>
                  <button
                    onClick={() =>
                      navigate(routePaths[idx % routePaths.length])
                    }
                    className="bg-[#00D084] hover:bg-green-600 text-white font-semibold px-6 w-fit py-2 rounded-full mt-auto mx-auto"
                  >
                    Learn More
                  </button>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* Blogs */}
    <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white font-poppins text-center">
  <h2 className="text-3xl sm:text-4xl font-bold text-[#00D084] mb-4">
    Our Blogs
  </h2>
  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">
    Powering Smart Urban Infrastructure with{" "}
    <span className="text-black font-extrabold">GyanYantram</span>
  </h3>
  <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-10">
    Explore how GyanYantram’s integrated solutions—VMD, PAS, ECB, Wi-Fi Routers,
    Cameras, and environmental sensors—are transforming cities into safer,
    more connected, and responsive environments. Stay updated with insights
    on our cutting-edge technology shaping modern urban infrastructure.
  </p>

  <Slider {...settings}>
    {blogPosts.map((post, idx) => (
      <div key={idx} className="px-2">
        <Link to={`/blog/${slugify(post.title)}`}>
          <div className="bg-gray-100 rounded-2xl shadow p-4 h-[520px] flex flex-col hover:shadow-lg transition duration-300">
            <div className="relative mb-4 rounded-xl overflow-hidden">
              <img
                src={post.img}
                alt={post.title}
                className="w-full h-56 object-cover"
              />
              <span className="absolute bottom-2 left-2 bg-[#00D084] text-white px-3 py-2 text-md font-semibold rounded-full">
                {post.tag}
              </span>
            </div>
            <h4 className="text-lg font-bold text-gray-900 mb-2">
              {post.title}
            </h4>
            <p className="text-gray-700 text-md mb-4 text-justify">
              {truncateWords(post.desc, 35)}
            </p>
            <div className="flex items-center mt-auto">
              <img
                src={post.authorImg}
                alt={post.author}
                className="w-10 h-10 rounded-full mr-3"
              />
              <div className="text-left">
                <p className="text-sm font-semibold text-gray-900">
                  {post.author}
                </p>
                <p className="text-sm text-gray-500">{post.date}</p>
              </div>
            </div>
          </div>
        </Link>
      </div>
    ))}
  </Slider>
</div>


      {/* FAQ */}
   <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-14 bg-white text-center font-poppins">
  <h3 className="text-[#00D084] text-[22px] font-bold mb-2">FAQs</h3>
  <h2 className="text-3xl sm:text-5xl font-extrabold text-black mb-4">
    Frequently Asked Questions
  </h2>
  <p className="text-black text-base sm:text-lg max-w-3xl mx-auto mb-12">
    Have questions about GyanYantram? Here's everything you need to know about our learning solutions, platform features, and support.
  </p>

  <div className="flex flex-col lg:flex-row items-start gap-8">
    {/* FAQ Accordion */}
    <div className="w-full lg:w-1/2 text-left bg-gray-50 rounded-xl">
      <details className="border rounded-md overflow-hidden">
        <summary className="bg-green-100 px-4 py-3 font-medium text-gray-900 cursor-pointer">
          What is GyanYantram?
        </summary>
        <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
          GyanYantram is a digital education platform designed to provide interactive learning experiences, online assessments, smart class integration, and real-time student monitoring for schools and institutions.
        </div>
      </details>
      <details className="border rounded-md overflow-hidden">
        <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
          Who can use GyanYantram?
        </summary>
        <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
          GyanYantram is built for schools, colleges, teachers, students, and education administrators who want to digitize their learning and teaching process with smart tools and content delivery.
        </div>
      </details>
      <details className="border rounded-md overflow-hidden">
        <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
          What features does GyanYantram offer?
        </summary>
        <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
          The platform offers live classes, recorded lectures, performance tracking, online exams, attendance management, digital content libraries, and seamless integration with smart classrooms.
        </div>
      </details>
      <details className="border rounded-md overflow-hidden">
        <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
          Can we access GyanYantram on mobile devices?
        </summary>
        <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
          Yes, GyanYantram is fully responsive and accessible on mobile phones, tablets, laptops, and desktops, making learning possible from anywhere, at any time.
        </div>
      </details>
      <details className="border rounded-md overflow-hidden">
        <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
          Is teacher training provided?
        </summary>
        <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
          Absolutely. GyanYantram provides complete training and onboarding sessions for educators, ensuring they can use the platform effectively for teaching and tracking student progress.
        </div>
      </details>
      <details className="border rounded-md overflow-hidden">
        <summary className="bg-white px-4 py-3 font-medium text-gray-900 cursor-pointer">
          Is GyanYantram customizable for different schools?
        </summary>
        <div className="px-4 py-3 text-gray-700 text-sm sm:text-base">
          Yes, the platform can be customized based on the institution’s curriculum, branding, and workflow requirements to create a tailored digital learning experience.
        </div>
      </details>
    </div>

    {/* FAQ Illustration */}
    <div className="w-full lg:w-1/2 flex justify-center">
      <img
        src={faq} // Replace with GyanYantram related illustration
        alt="GyanYantram Platform"
        className="h-40 sm:h-52 md:h-64 lg:h-80 xl:h-96 object-contain"
      />
    </div>
  </div>
</div>

      {/* Meet Our Founder */}
      <div className="w-full bg-white pb-8 px-4 lg:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mx-auto mb-16" data-aos="fade-up">
            <h1 className="text-5xl font-bold text-gray-800 mb-6">
              Meet Our Founder & Director
            </h1>
           <p className="text-black max-w-3xl mx-auto text-lg">
  Meet the innovative minds behind GyanYantram — a dedicated team of experts committed to transforming learning through smart technology, digital solutions, and impactful education tools.
</p>

          </div>

          <div
            className="flex justify-center flex-wrap gap-12"
            data-aos="fade-up"
          >
            {/* Adviser Card */}
            <div className="w-full max-w-sm bg-gray-100 shadow-xl rounded-2xl overflow-hidden text-center group transition-all duration-300 hover:shadow-2xl">
              <div className="flex justify-center mt-5">
                <div className="p-2 rounded-full border-4 border-dotted border-[#00D084]">
                  <img
                    src={vishal}
                    alt="Vishal Gupta"
                    className="w-80 h-80 object-cover rounded-full transform group-hover:scale-105 transition duration-300"
                  />
                </div>
              </div>

              <div className="py-6 px-6">
                <h4 className="text-2xl font-bold text-gray-800 mb-2">
                  Vishal Gupta
                </h4>
                <p className="text-gray-500 text-base mb-4">
                  Founder & Director
                </p>

                <div className="flex justify-center space-x-4 mt-4">
                  <a
                    href="https://x.com/vgajeevi?s=11"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center bg-[#00D084] text-white rounded-full hover:bg-green-700 text-lg"
                  >
                    <FaXTwitter />
                  </a>
                  <a
                    href="https://www.linkedin.com/in/vgajeevi/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center bg-[#00D084] text-white rounded-full hover:bg-green-700 text-lg"
                  >
                    <FaLinkedinIn />
                  </a>
                  <a
                    href="https://www.instagram.com/vgajeevi?igsh=cjF3MXQ3N2NrYjYx"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center bg-[#00D084] text-white rounded-full hover:bg-green-700 text-lg"
                  >
                    <FaInstagram />
                  </a>
                </div>
              </div>
            </div>

            {/* Add more adviser cards here if needed */}
          </div>
        </div>
      </div>
    </>
  );
}

